import styled from 'styled-components';
import { msColors } from 'src/style/themes/defaultTheme';

const PRIMARY = '#1976d2'; // the theme blue one step darker, so white text passes AA (4.6:1)

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Fields = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
`;

export const WeekdaysRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    > span {
        font-size: 13px;
        color: ${msColors.primaryTextcolor};
        margin-inline-end: 4px;
    }
`;

export const WeekdayButton = styled.button<{ $pressed?: boolean }>`
    flex: 1;
    min-width: 0;
    height: 32px;
    border: 1px solid ${PRIMARY};
    border-radius: 16px;
    background: ${({ $pressed }) => ($pressed ? PRIMARY : 'white')};
    color: ${({ $pressed }) => ($pressed ? 'white' : PRIMARY)};
    font-size: 13px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${PRIMARY};
        outline-offset: 1px;
    }

    &:disabled {
        cursor: default;
        opacity: 0.5;
    }
`;

export const Status = styled.div`
    font-size: 13px;
    color: ${msColors.darkTextcolor};
    background: #eef4fc;
    border-radius: 4px;
    padding: 6px 10px;
`;
